import React, { useState, useEffect } from "react";
import { Grid } from "@progress/kendo-react-grid";
import { Grid as LayoutGrid } from "@mui/material";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { DEFAULT_PAGE_SIZE } from "../../Utilities/constants";
import "./DataGrid.scss";

export const DataGridPager = (props) => {
  const currentPage = Math.floor(props.skip / props.take);
  const totalPages = Math.ceil((props.total || 0) / props.take);

  const nextPage = (e) => {
    props.onPageChange({
      target: null,
      skip: Math.min(currentPage + 1, totalPages - 1) * props.take,
      take: props.take,
      syntheticEvent: e,
      nativeEvent: e.nativeEvent,
    });
  };

  const prevPage = (e) => {
    props.onPageChange({
      target: null,
      skip: Math.max(currentPage - 1, 0) * props.take,
      take: props.take,
      syntheticEvent: e,
      nativeEvent: e.nativeEvent,
    });
  };

  const updateTake = (e) => {
    props.onPageChange({
      target: null,
      skip: 0,
      take: e.target.value,
      syntheticEvent: e,
      nativeEvent: e.nativeEvent,
    });
  };

  const pageSizeOptions = [5, 10, 15, 20, 25, 30];
  
  const paginationInfo = props.total === 0
      ? "0 - 0 of 0" : `${props.skip + 1} - ${Math.min(
                          props.skip + props.take,
                          props.total
                       )} of ${props.total}`;

  return (
    <div
      className={props.className}
      style={{ borderTop: "1px solid", borderTopColor: "inherit" }}
    >
      <LayoutGrid className={"instream-data-grid-pager"} container spacing={3}>
        <LayoutGrid item xs={4}>
          &nbsp;
        </LayoutGrid>
        <LayoutGrid item xs={8}>
          <div className={"instream-data-grid-pager-controls"}>
            <div className={"pager-select"}>
              <label>Rows Per Page: </label>
              <DropDownList
                data={pageSizeOptions}
                value={props.take}
                onChange={(event) => {
                  updateTake(event);
                }}
              />
            </div>
            <div className={"pager-current"}>
              {paginationInfo}
            </div>
            <div className={"pager-navigation"}>
              <a href={"javascript:void()"} onClick={prevPage}>
                <ChevronLeftIcon />
              </a>
              <a href={"javascript:void()"} onClick={nextPage}>
                <ChevronRightIcon />
              </a>
            </div>
          </div>
        </LayoutGrid>
      </LayoutGrid>
    </div>
  );
};

const DataGrid = (props) => {
  const [state, setState] = useState({
    skip: 0,
    take: DEFAULT_PAGE_SIZE,
  });

  useEffect(() => {
    if (!props.lastIndex) return;

    let index = -1;
    let maxEditIndex = -1;
    props.data.forEach((item, i) => {
      if (item.editIndex > maxEditIndex) {
        index = i;
        maxEditIndex = item.editIndex;
      }
    });

    const page = Math.floor(index / state.take);

    setState({
      ...state,
      skip: page * state.take,
    });
  }, [props.lastIndex]);

  const onPageChange = props.onPageChange
    ? props.onPageChange
    : (event) => {
        setState({
          skip: event.page.skip,
          take: event.page.take,
        });
      };

  const skip = props.skip ? props.skip : state.skip;
  const take = props.take ? props.take : state.take;
  const total = props.data.length;

  const getData = () => {
    if (props.hidePager) return props.data;

    if (skip >= total) {
      setState({
        skip: skip - take,
        take: take,
      });

      return props.data.slice(skip - take, skip);
    }

    return props.data.slice(skip, skip + take);
  };

  const data = getData();

  const scrollable = props.scrollable ? props.scrollable : "none";

  const borderClass = props.noBorder ? "no-border" : "";

  const hidePagerClass = props.hidePager ? "instream-hide-pager" : "";

  const className = props.className
    ? `${props.className} instream-data-grid ${borderClass} ${hidePagerClass}`
    : `instream-data-grid ${borderClass} ${hidePagerClass}`;

  return (
    <Grid
      {...props}
      data={data}
      skip={skip}
      take={take}
      total={total}
      pageable={!props.hidePager}
      onPageChange={onPageChange}
      className={className}
      pager={DataGridPager}
      scrollable={scrollable}
      onRowClick={props.onRowClick}
    >
      {props.children}
    </Grid>
  );
};

export default DataGrid;
